<div class="h-100 d-flex flex-column">
  
  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
  <app-nav></app-nav>
</div>
